import { CancelToken } from 'axios';
import { emperor } from '~/services';
import { IFreeBuildingSummary } from '~/types/freeBuildingsSummary';

export const getFreeBuildingsSummaryRequest = async (
  cancelToken?: CancelToken
): Promise<{ data: IFreeBuildingSummary[] }> => {
  return await emperor.get('/free-buildings/summary', { cancelToken });
};
